import React from 'react';
import firebase from '../firebase';
import { Link } from 'react-router-dom';

export const Component = () => {
  const [sending, setSending] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const target: any = e.target;
    const email = target.email.value;
    console.log(email);
    setSending(true);
    e.preventDefault();
    firebase
      .auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(function () {
        setSending(false);
        setSuccess(true);
      })
      .catch(function (error) {
        setSending(false);
        setSuccess(true);
        console.error(error.code);
      });
  };

  var actionCodeSettings = {
    url: `${window.location.origin}/login`,
    handleCodeInApp: true,
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <div>
            <label htmlFor="email">email</label>
            <input id="email" name="email" />
          </div>
          {success ? (
            <div>
              <Link to="./">
                <button>Go Home</button>
              </Link>
            </div>
          ) : (
            <div>
              <button disabled={sending}>Send email link</button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};
